import { Link } from "react-router-dom";
import logo from "../../images/logo.webp";
import Shape1 from "../../images/mail.svg";
import News1 from "../../images/phone.svg";
import News2 from "../../images/map.svg";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={logo} alt="blog" />
                </div>
                <p>
                  The Cash Flow Summit 2026 is a one-day mega event designed to
                  help entrepreneurs, business owners, and professionals master
                  the art of cash flow control, financial freedom, and long-term
                  stability.
                </p>

                <div className="social-widget">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/JagmohanSinghCashFlowCoach"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="ti-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://x.com/Jsa_online"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="ti-twitter-alt"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/jagmohanjda/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="ti-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/jsa_online_support_services/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="ti-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About Summit
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/summit-objective">
                      Summit Objective
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/global-tour">
                      Global Tour
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget s2">
                <div className="widget-title">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/sponsorship">
                      Sponsorship
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/testimonials">
                      Testimonial
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget contact-widget">
                <div className="widget-title">
                  <h3>Contact Us</h3>
                </div>
                <ul>
                  <li>
                    <img src={News2} alt="" />
                    <span>
                      9th Floor, Unit No. 904, SPTS Tower, Community Centre,
                      <br />
                      Janakpuri, West Delhi,
                      <br />
                      Delhi – 110058
                    </span>
                  </li>
                  <li>
                    <img src={Shape1} alt="" />
                    <span>ea@jsa.net.in</span>
                  </li>
                  <li>
                    <img src={News1} alt="" /> <span>+91 98212 61071</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                {" "}
                Copyright &copy; 2026 Cash Flow Summit 2026 by{" "}
                <Link onClick={ClickHandler} to="/">
                  JSA Online
                </Link>
                .
              </p>
            </div>
            <div className="col col-lg-6 col-12">
              <ul>
                <li>
                  <Link onClick={ClickHandler} to="/privacy">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/terms-and-conditions">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/about">
                    About us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
